var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion14X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.974,4.324L29.27,-0.222L48.222,19.831L27.656,39.778L23.55,35.039L36.021,22.944L-0.222,22.944L-0.222,16.515L36.496,16.515L24.974,4.324Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    transform: "rotate(-180 24 19.778)",
    fill: "#1B1B1D",
    stroke: "#1B1B1D",
    strokeWidth: 1,
    strokeMiterlimit: 3.999327
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion14X2);
export default __webpack_public_path__ + "static/media/union_14_x2.115d5ae6d0f085d9e0cdde59d756ce0e.svg";
export { ForwardRef as ReactComponent };